import { createFileRoute } from "@tanstack/react-router";

import ManagePaymentMethods from "@/shared/components/payment-methods/ManagePaymentMethods";

export const Route = createFileRoute("/_authenticated/settings/payment-methods/")({
  component: ManagePaymentMethods,
  context: () => ({ permissions: "settings.payment-methods" }),
});
